import { render } from "./SponsorsComponent.vue?vue&type=template&id=1d3f92fc"
import script from "./SponsorsComponent.vue?vue&type=script&lang=js"
export * from "./SponsorsComponent.vue?vue&type=script&lang=js"

import "./SponsorsComponent.vue?vue&type=style&index=0&id=1d3f92fc&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__